module.exports = __webpack_public_path__ + "img/icon-experience.a13ce495.png";